module.exports = __webpack_public_path__ + "static/media/caret-right.4f09fa74.svg";